export default {"src":"/_next/static/media/Comprehensive Follow-Up Care.bc4b8f52.svg","height":52,"width":51,"blurWidth":0,"blurHeight":0};